import { Button, ButtonsGroup, Modal, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { LegalSettingTypes } from '../../../../../../enums/legalSettingTypes'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

interface LegalGuaranteeOfConformityModalFooterProps {
  id: string
}

export const LegalGuaranteeOfConformityModalFooter = ({
  id,
}: LegalGuaranteeOfConformityModalFooterProps): ReactElement => {
  const { t } = useTranslation()
  const { setValue: setInvoiceSettingsFormValue } = useFormContext<InvoiceSettingsFormSchema>()
  const { close: closeModal } = useModal(id)

  const handleEnableChange = useCallback(
    (enabled: boolean) => {
      setInvoiceSettingsFormValue(`legalFormSettings.${LegalSettingTypes.IsLegalGuaranteeOfConformity}`, enabled, {
        shouldDirty: true,
      })
      closeModal()
    },
    [setInvoiceSettingsFormValue, closeModal],
  )

  return (
    <Modal.Footer>
      <ButtonsGroup>
        <Button variant="text" onClick={() => handleEnableChange(false)}>
          {t('settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.keep_off')}
        </Button>
        <Button onClick={() => handleEnableChange(true)}>
          {t('settings.organization.external_invoice.legal_mentions.legal_guarantee_of_conformity.modal.enable')}
        </Button>
      </ButtonsGroup>
    </Modal.Footer>
  )
}
